// extracted by mini-css-extract-plugin
module.exports = {"loading":"Card_loading___OjFs","game-card":"Card_game-card__LQBBn"};